export const SLIDE_WIDTH = 200;
export const SLIDE_HEIGHT = 95;
export const THUMBNAIL_HEIGHT = 81;
export const THUMBNAIL_WIDTH = 144;
export const BORDER_WIDTH = 2;
export const ADD_NEW_SLIDES_ID = 'pagemanager-add-new-slides';
